























































import { Component, Vue } from 'vue-property-decorator'
import { updateSelfInfo, getUserInfo, updatePwd } from '@/api/api'
import axios from 'axios'

@Component({})
export default class EditBasicInfo extends Vue {
  basicInfo: any = {}
  isChangePwd: boolean = false
  oldPasswd: string = ''
  newPasswd: string = ''
  CheckNewPasswd: string = ''

  mounted() {
    this.basicInfo = JSON.parse(sessionStorage.userInfo)
    console.log(this.basicInfo)
  }

  /**
   * 返回我的主页
   */
  returnCenter(): void {
    this.$emit('returnEvent')
  }

  /**
   * 保存
   */
  submitBasicInfo(): void {
    console.log('修改基本资料')
    let check = false

    if (!this.basicInfo.true_name) {
      this.$message.warning('姓名不能为空')
    } else {
      check = true
    }

    if (check) {
      this._updateUserInfo()
    }
  }

  _updateUserInfo(): void {
    const load = this.$loading({
      lock: true,
      text: '加载中',
      background: 'rgba(0, 0, 0, 0.7)'
    })

    this.basicInfo.department = '科技部'
    updateSelfInfo(this.basicInfo)
      .then((res: any) => {
        load.close()
        console.log(res)
        if (res.data.code === 101) {
          this.$message.success('操作成功')
          getUserInfo().then((res: any) => {
            sessionStorage.setItem('userInfo', JSON.stringify(res.data.result))
            this.basicInfo = JSON.parse(sessionStorage.userInfo)
          })
        }
      })
      .catch(_ => {
        load.close()
      })
  }

  /**
   * 图片上传
   */
  uploadImg(options: any) {
    const load = this.$loading({
      lock: true,
      text: '加载中',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    const vm = this
    let file = options.file
    let filename = file.name
    const fileType = options.file.name.split('.')[1]
    const reader = new FileReader()
    if (file) {
      reader.readAsDataURL(file)
    }
    reader.onload = () => {
      let base64Str: any = reader.result
      let config: any = {
        url: '/api/file/uploadFile',
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          Authorization: window.localStorage.getItem('userToken')
        },
        // file: file,
        data: {
          file: base64Str.split(',')[1],
          file_type: fileType
        },
        timeout: 10000,
        onUploadProgress: function(progressEvent: any) {
          // console.log(progressEvent)
          progressEvent.percent = (progressEvent.loaded / progressEvent.total) * 100
          options.onProgress(progressEvent, file)
        }
      }

      const loading = this.$loading({
        lock: true,
        text: '上传图片中',
        // spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios(config)
        .then((res: any) => {
          loading.close()
          if (res.data.code === 101) {
            options.onSuccess(res, file)
            console.log(res)
            // vm.imgPath = res.data.result.file_path
            // vm.imgUrl = res.data.result.file_links
            this.basicInfo.image = res.data.result.file_path
            this._updateUserInfo()
            console.log('success')
          }
        })
        .catch((err: any) => {
          loading.close()
          options.onError(err)
        })
    }
  }

  uploadPassWord() {
    if (this.oldPasswd === '') {
      this.$message.warning('请输入旧密码')
    } else if (this.newPasswd === '') {
      this.$message.warning('请输入新密码')
    } else if (this.CheckNewPasswd === '') {
      this.$message.warning('请再次输入新密码')
    } else if (this.newPasswd !== this.CheckNewPasswd) {
      this.$message.warning('两次输入不一致')
    } else {
      updatePwd({
        check_new_pwd: this.CheckNewPasswd, //新密码确认
        new_pwd: this.newPasswd,
        old_pwd: this.oldPasswd
      }).then((res: any) => {
        if (res.data.code === 101) {
          this.$message.success('操作成功')
          this.CheckNewPasswd = ''
          this.oldPasswd = ''
          this.newPasswd = ''
        } else {
          this.$message.error(res.data.message)
        }
      })
    }
  }
}
